import { ORDER_FILTER_TYPE } from 'pages/NewDashboard/components/Summary/components/OrderContainer/OrderHeader/constants'

export interface IOrderSummaryDateFilter {
  startTime?: number
  endTime?: number
  filterType: ORDER_FILTER_TYPE
}

export enum ORDER_SUMMARY_TYPES {
  ORDER_SUMMARY = 1,
  ORDER_SUMMARY_ITEMS = 2,
  ORDER_SUMMARY_BY_GROUP_ID = 3
}

export interface IOrderSummaryState {
  loaders: {
    orderSummary: boolean
    allOrderListLoader: boolean
    groupSummary: boolean
    overallGroupSummary: boolean
  }
  activeFilter: IOrderSummaryDateFilter | null
  orderSummaryData: IOrderSummaryStats | null
  allOrderListData: IOrderSummaryFormattedData[] | null
  groupViewData: IOrderSummaryGroupFormattedData | null
  selectedGroupId: string | null
  drawers: {
    orderSummaryDownload: false
  }
  overallOrderGroupData: {
    data: IOrderSummaryItemLevelStatsV2[]
    limit: number
    page: number
    totalItems: number
  }
}

export interface IFetchOrderSummaryActionPayload {
  startTime: number
  endTime: number
  filterType: ORDER_FILTER_TYPE
}

export interface IFetchOrderGroupSummaryActionPayload {
  startTime: number
  endTime: number
  filterType: ORDER_FILTER_TYPE
  groupId: string
  page?: number
  limit?: number
}

export interface IOrderSummaryFormattedData {
  groupName: string
  totalOrders: number
  totalAmount: number
  totalAcceptedAmount: number
  totalPendingAmount: number
}

export interface IOrderSummaryListFormattedData extends IOrderSummaryFormattedData {
  groupId: string
}

export enum ORDER_STATUS_TYPES {
  DEFAULT = 0,
  PENDING = 1,
  APPROVED = 2,
  PROFORMA_CREATED = 3,
  INVOICED = 4,
  CANCELLED = 5,
  REJECTED = 6,
  OUT_FOR_DELIVERY = 7,
  COMPLETED = 8
}

export interface IOrderSummaryGroupFormattedData extends IOrderSummaryListFormattedData {
  orderDetails: {
    number: string
    customerName: string
    amount: number
    status: ORDER_STATUS_TYPES
    createTime: string
    updateTime: string
  }[]
}

export interface IFetchOrderGroupSummaryDownlaodActionPayload
  extends IFetchOrderGroupSummaryActionPayload {
  fileName: string
}

export interface IOrderSummaryStats {
  group_name: string
  total_orders: number
  total_orders_value: number
  total_ordered_qty: number
  total_accepted_qty: number
  total_rejected_qty: number
  total_pending_qty: number
  total_pending_orders_value: number
}
/** @deprecated */
export interface IOrderSummaryItemLevelStats {
  order_number: string
  customer_name: string
  zone: string
  area: string
  item_category: string
  sales_person: string
  item_name: string
  sku: string
  rate: number
  ordered_quantity: number
  order_item_value: number
}

export type LabelId = string
export type LabelValues = string
export interface IOrderSummaryItemLevelStatsV2 {
  order_number: string
  order_status: string
  customer_name: string
  labels?: Record<LabelId, LabelValues[]>
  sales_person: string
  item_name: string
  sku: string
  rate: number
  ordered_quantity: number
  order_item_value: number
  updatedLabelsObject?: Record<LabelId, LabelValues[]>
  invoiced_quantity: number
}
